import { SELECTED_USER_TYPE, SELECTED_MERCHANT } from "globals/variables";

const removeSelectedInfo = (): void => {
  window.sessionStorage.removeItem(SELECTED_MERCHANT);
  window.sessionStorage.removeItem(SELECTED_USER_TYPE);
};

export default removeSelectedInfo;
